import React from "react";

export function SystemError() {
    return (
        <div className="validation-error-box">
            <p>現在システムエラーが発生しております。お急ぎの場合は当社コールセンターまでお電話にてお問い合わせください。</p>
        </div>
    );
}